import React from "react";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { StyledGrid, StyledRow, StyledCol, StyledSpanTotal, StyledSpanDeposit } from "../styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const TAX_VALUE = 0.1;

const messages = defineMessages({
  total: {
    id: "quotation.cardTotal.total",
    defaultMessage: "Total",
  },
  totalWithoutTax: {
    id: "quotation.cardTotal.totalWithoutTax",
    defaultMessage: "Total sin impuestos:",
  },
  taxes: {
    id: "quotation.cardTotal.taxes",
    defaultMessage: "Impuestos (IVA 10%)",
  },
  footer: {
    id: "quotation.cardTotal.footer",
    defaultMessage: "El precio en",
  },
  footer2: {
    id: "quotation.cardTotal.footer2",
    defaultMessage: "es meramente orientativo, la divisa del hotel es",
  },
  footer3: {
    id: "quotation.cardTotal.footer3",
    defaultMessage: "moneda en la que se facturará el servicio",
  },
  tooltipTotal: {
    id: "quotation.cardTotal.tooltipTotal",
    defaultMessage: "tooltipTotal",
  },
  payNow: {
    id: "quotation.cardTotal.payNow",
    defaultMessage: "payNow",
  },
  payAtHotel: {
    id: "quotation.cardTotal.payAtHotel",
    defaultMessage: "payAtHotel",
  },
});

export const OriginalTotal: any = ({ tab, total, ratio }: any) => {
  const intl = useIntl();

  const newTotal = total / ratio || 0;

  return (
    <StyledGrid style={{ paddingTop: "24px", paddingBottom: "24px" }}>
      <StyledRow>
        <StyledCol xs={12}>
          <StyledSpanTotal>
            {`${intl.formatMessage(messages.total)} (${
              tab?.configurations?.currencyExchange?.currencyBase || "EUR"
            }): ${newTotal.toFixed(2)}`}
          </StyledSpanTotal>
        </StyledCol>
        <StyledCol xs={12} style={{ marginTop: "8px" }}>
          <span>
            {`${intl.formatMessage(messages.totalWithoutTax)} ${
              tab?.configurations?.currencyExchange?.currencyBase || "EUR"
            } ${(newTotal - newTotal * TAX_VALUE || 0).toFixed(2)}`}
          </span>
        </StyledCol>
        <StyledCol xs={12} style={{ marginTop: "8px" }}>
          <span>
            {`${intl.formatMessage(messages.taxes)} (${
              tab?.configurations?.currencyExchange?.currencyBase || "EUR"
            }): ${(newTotal * TAX_VALUE || 0).toFixed(2)}`}
          </span>
        </StyledCol>
        <StyledCol xs={12} style={{ marginTop: "16px", fontSize: 11 }}>
          <>
            <FontAwesomeIcon icon={faInfoCircle} color="#B3B3B3" style={{ marginRight: 5 }} />
            <FormattedMessage {...messages.tooltipTotal} />
          </>
        </StyledCol>
      </StyledRow>
    </StyledGrid>
  );
};

export const CurrencyExchangeTotal: any = ({ tab, total }: any) => {
  const intl = useIntl();
  return (
    (tab?.configurations?.currencyExchange?.currencyBase || "EUR") !==
      (tab?.currency?.label || "EUR") && (
      <StyledGrid style={{ paddingTop: "24px", paddingBottom: "24px" }}>
        <StyledRow>
          <StyledCol xs={12}>
            <StyledSpanTotal>
              {" "}
              {`${intl.formatMessage(messages.total)} (${tab?.currency?.label}): ${
                total || 0
              }`}{" "}
            </StyledSpanTotal>
          </StyledCol>
          <StyledCol xs={12} style={{ marginTop: "8px" }}>
            <span>
              {`${intl.formatMessage(messages.totalWithoutTax)} (${tab?.currency?.label}) ${(
                total - total * TAX_VALUE || 0
              ).toFixed(2)}`}
            </span>
          </StyledCol>
          <StyledCol xs={12} style={{ marginTop: "8px" }}>
            <span>
              {`${intl.formatMessage(messages.taxes)} (${tab?.currency?.label}): ${(
                total * TAX_VALUE || 0
              ).toFixed(2)}`}
            </span>
          </StyledCol>

          <StyledCol xs={12} style={{ marginTop: "20px" }}>
            <span style={{ color: "#B3B3B3", fontSize: "13px", fontFamily: "Arial" }}>
              {`${intl.formatMessage(messages.footer)} ${tab?.currency?.label} ${intl.formatMessage(
                messages.footer2
              )} ${tab?.configurations?.currencyExchange?.currencyBase || "EUR"},
              ${intl.formatMessage(messages.footer3)}`}
            </span>
          </StyledCol>
        </StyledRow>
      </StyledGrid>
    )
  );
};

export const Deposit: any = ({ tab, total, deposit }: any) => {
  const intl = useIntl();

  return (
    <StyledGrid style={{ paddingBottom: "24px" }}>
      <StyledRow>
        <StyledCol xs={12}>
          <StyledSpanDeposit>
            {`${intl.formatMessage(messages.payNow)} (${
              tab?.configurations?.currencyExchange?.currencyBase || "EUR"
            }): ${Number(deposit).toFixed(2)}`}
          </StyledSpanDeposit>
        </StyledCol>
        <StyledCol xs={12}>
          <StyledSpanDeposit>
            {`${intl.formatMessage(messages.payAtHotel)} (${
              tab?.configurations?.currencyExchange?.currencyBase || "EUR"
            }): ${Number(total - deposit).toFixed(2)}`}
          </StyledSpanDeposit>
        </StyledCol>
      </StyledRow>
    </StyledGrid>
  );
};
